import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo, PAGE_SEO } from "../seo";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    const seo = PAGE_SEO[pathname];
    if (seo) {
      applySeo(seo);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
